window.kgProductPageVariantId = false;
window.kgFreeGiftSizeSelected = false;
window.kgMainFreeGiftVariantId = false;

window.kgAddToCartFreeGifts = function () {
  // Require the customer to explicitly select a size
  if (!window.kgFreeGiftSizeSelected || !window.kgMainFreeGiftVariantId) {
    showKgSizeRequiredMessage();
    return;
  }

  if (
    !window.kgOtherFreeGiftVariantId ||
    !window.kgProductPageVariantId
  ) {
    console.error("Missing required product variant ID.");
    return;
  }

  try {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: window.kgOtherFreeGiftVariantId,
            quantity: 1,
            properties: {
              _free_gift: true,
            },
          },
          {
            id: window.kgMainFreeGiftVariantId,
            quantity: 1,
            properties: {
              _free_gift: true,
            },
          },
          {
            id: window.kgProductPageVariantId,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Unable to add products to cart.");
        }

        return response.json();
      })
      .then((data) => {
        const kgCustomProductDiv =
          document.querySelector(".kg-popup-overlay");

        if (kgCustomProductDiv) {
          kgCustomProductDiv.classList.remove("kg-active");
          kgCustomProductDiv.style.display = "none";
        }

        monster_refresh();

        console.log("Added to cart:", data);
      })
      .catch((error) => {
        console.error("Error adding free gifts:", error);
      });
  } catch (error) {
    console.error("Error adding free gifts:", error);
  }
};


/*
 * IMPORTANT:
 * The customer can no longer close the free-gift popup
 * and add only the main product.
 *
 * This function is intentionally kept empty except for
 * showing the size requirement message.
 */
window.kgAddToCartOnlyMainProduct = function () {
  showKgSizeRequiredMessage();
};


/*
 * Creates the required-size message dynamically.
 * No changes are required in the Liquid file.
 */
function showKgSizeRequiredMessage() {
  const popup = document.querySelector(".kg-popup-overlay");

  if (!popup) return;

  let message = popup.querySelector(".kg-size-required-message");

  if (!message) {
    message = document.createElement("div");
    message.className = "kg-size-required-message";

    message.textContent =
      "Please select your Nursing Bra size to continue.";

    message.style.cssText = `
      display: block;
      color: #b35c5c;
      font-size: 13px;
      line-height: 1.4;
      text-align: center;
      margin: 10px 0 0;
      width: 100%;
    `;

    const button = popup.querySelector(
      ".kg-add-to-cart-free-gifts-button"
    );

    if (button && button.parentNode) {
      button.parentNode.insertBefore(message, button);
    } else {
      popup.querySelector(".kg-content-wrap")?.appendChild(message);
    }
  }

  message.style.display = "block";
}


/*
 * Removes the required-size message.
 */
function hideKgSizeRequiredMessage() {
  const message = document.querySelector(
    ".kg-size-required-message"
  );

  if (message) {
    message.style.display = "none";
  }
}


document.addEventListener("DOMContentLoaded", function () {
  const kgSizeSelect =
    document.getElementById("kgSizeSelect");

  const kgAddToCartFreeGiftsButton =
    document.querySelector(
      ".kg-add-to-cart-free-gifts-button"
    );

  const kgProductPageATCButton =
    document.querySelector(".kg-add-to-cart-button");

  const kgFreeGiftModalCloseButton =
    document.querySelector(".kg-close-link");


  /*
   * CLOSE BUTTON
   *
   * Previously this added only the main pump to the cart.
   * That allowed customers to bypass the free-gift size selection.
   *
   * Now clicking Close does NOT add anything to the cart.
   */
  if (kgFreeGiftModalCloseButton) {
    kgFreeGiftModalCloseButton.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        /*
         * Do not allow the customer to bypass
         * the required free-gift selection.
         */
        showKgSizeRequiredMessage();
      }
    );
  }


  /*
   * PRODUCT PAGE ADD TO CART
   *
   * Opens the free-gift popup and resets the size
   * requirement every time the customer starts a new
   * add-to-cart action.
   */
  if (kgProductPageATCButton) {
    kgProductPageATCButton.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const kgCustomProductDiv =
          document.querySelector(".kg-popup-overlay");

        if (kgCustomProductDiv) {
          /*
           * Reset the free-gift selection every time
           * the popup opens.
           */
          window.kgFreeGiftSizeSelected = false;
          window.kgMainFreeGiftVariantId = false;

          hideKgSizeRequiredMessage();

          window.kgProductPageVariantId = Number(
            document.querySelector(".product-variant-id").value
          );

          kgCustomProductDiv.classList.add("kg-active");
          kgCustomProductDiv.style.display = "block";
        }
      }
    );
  }


  /*
   * Function to update the selected color value display.
   */
  function updateSelectedColorDisplay() {
    const colorSelectedValue =
      document.querySelector(
        ".kg-selected-value[data-option-name]"
      );

    if (colorSelectedValue) {
      let colorInput =
        document.querySelector(
          ".kg-variant-picker--swatch .swatch-input__input:checked"
        );

      if (!colorInput) {
        colorInput =
          document.querySelector(
            ".kg-variant-picker--swatch input[type='radio']:checked"
          );
      }

      if (colorInput) {
        const colorValue = colorInput.value;

        const colorLabel =
          colorInput.closest("label") ||
          colorInput.nextElementSibling;

        let colorText = colorValue;

        if (colorLabel) {
          colorText =
            colorLabel.getAttribute("title") ||
            colorLabel.textContent.trim() ||
            colorValue;
        }

        colorSelectedValue.textContent = colorText;
      }
    }
  }


  /*
   * Function to update images based on color selection.
   */
  function updateVariantImages() {
    const allVariantImages =
      document.querySelectorAll(".kg-variant-image");

    const selectedColorInput =
      document.querySelector(
        ".kg-variant-picker--swatch input[type='radio']:checked, .kg-variant-picker--swatch .swatch-input__input:checked"
      );

    const selectedColorValue =
      selectedColorInput
        ? selectedColorInput.value
        : null;

    if (selectedColorValue) {
      allVariantImages.forEach(function (img) {
        const colorValue =
          img.getAttribute("data-color-value");

        const variantId =
          img.getAttribute("data-variant-id");

        if (
          variantId &&
          colorValue &&
          colorValue === selectedColorValue
        ) {
          img.style.display = "block";
        } else if (variantId) {
          img.style.display = "none";
        } else {
          img.style.display = "block";
        }
      });
    } else {
      let imageShown = false;

      allVariantImages.forEach(function (img) {
        const variantId =
          img.getAttribute("data-variant-id");

        if (!variantId) {
          img.style.display = "block";
          imageShown = true;
        } else if (!imageShown) {
          img.style.display = "block";
          imageShown = true;
        } else {
          img.style.display = "none";
        }
      });
    }
  }


  /*
   * Updates the selected free-gift variant.
   *
   * IMPORTANT:
   * A variant is ONLY considered valid if the customer
   * has explicitly selected the SIZE.
   *
   * We no longer fall back to the first available variant.
   */
  function updateSelectedVariant() {
    const variantsData =
      document.getElementById("kg-product-variants");

    if (!variantsData) return;

    try {
      const variants =
        JSON.parse(variantsData.textContent);

      const allOptionInputs =
        document.querySelectorAll(
          ".kg-variant-picker input[type='radio']:checked"
        );

      const selectedOptionsByPosition = {};

      /*
       * Check whether a size has actually been selected.
       */
      const selectedSizeInput =
        document.querySelector(
          ".kg-variant-picker--pill input[type='radio']:checked"
        );

      /*
       * If there is a size picker and no size has been
       * explicitly selected, there is NO valid variant.
       */
      const hasSizePicker =
        document.querySelector(
          ".kg-variant-picker--pill"
        );

      if (hasSizePicker && !selectedSizeInput) {
        window.kgFreeGiftSizeSelected = false;
        window.kgMainFreeGiftVariantId = false;

        updateVariantImages();
        updateSelectedColorDisplay();

        return;
      }


      /*
       * Build selected options by position.
       */
      allOptionInputs.forEach(function (input) {
        let optionPosition =
          input.getAttribute("data-option-position");

        if (!optionPosition) {
          const nameMatch =
            input.name.match(
              /kgOption-[^-]+-(\d+)/
            );

          if (nameMatch) {
            optionPosition = nameMatch[1];
          }
        }

        if (optionPosition) {
          selectedOptionsByPosition[
            parseInt(optionPosition)
          ] = input.value;
        }
      });


      /*
       * Find the variant matching ALL selected options.
       */
      let matchedVariant = null;

      const selectedPositions =
        Object.keys(selectedOptionsByPosition);

      if (selectedPositions.length > 0) {
        for (let i = 0; i < variants.length; i++) {
          const variant = variants[i];

          let allOptionsMatch = true;

          selectedPositions.forEach(
            function (positionStr) {
              const position =
                parseInt(positionStr);

              const selectedValue =
                selectedOptionsByPosition[position];

              let optionMatches = false;

              if (
                position === 1 &&
                variant.option1 &&
                variant.option1 === selectedValue
              ) {
                optionMatches = true;
              } else if (
                position === 2 &&
                variant.option2 &&
                variant.option2 === selectedValue
              ) {
                optionMatches = true;
              } else if (
                position === 3 &&
                variant.option3 &&
                variant.option3 === selectedValue
              ) {
                optionMatches = true;
              }

              if (!optionMatches) {
                allOptionsMatch = false;
              }
            }
          );

          if (allOptionsMatch) {
            matchedVariant = variant;
            break;
          }
        }
      }


      /*
       * IMPORTANT:
       * Never automatically choose the first available variant.
       */
      if (!matchedVariant) {
        window.kgMainFreeGiftVariantId = false;

        console.log(
          "No valid free-gift variant selected."
        );

        updateVariantImages();
        updateSelectedColorDisplay();

        return;
      }


      /*
       * Only accept an available variant.
       */
      if (!matchedVariant.available) {
        window.kgMainFreeGiftVariantId = false;

        console.log(
          "Selected free-gift variant is unavailable."
        );

        updateVariantImages();
        updateSelectedColorDisplay();

        return;
      }


      /*
       * Valid explicit selection.
       */
      window.kgMainFreeGiftVariantId =
        matchedVariant.id;

      console.log(
        "Updated Free Gift Variant ID:",
        window.kgMainFreeGiftVariantId
      );

      console.log(
        "Matched Variant:",
        matchedVariant
      );


      updateVariantImages();
      updateSelectedColorDisplay();

    } catch (error) {
      console.error(
        "Error updating variant:",
        error
      );

      window.kgMainFreeGiftVariantId = false;
    }
  }


  /*
   * All variant inputs.
   */
  const allOptionInputs =
    document.querySelectorAll(
      ".kg-variant-picker input[type='radio']"
    );


  /*
   * Swatch inputs.
   */
  const swatchInputs =
    document.querySelectorAll(
      ".kg-variant-picker .swatch-input__input"
    );


  /*
   * Combine all inputs.
   */
  const allInputs =
    Array.from(allOptionInputs).concat(
      Array.from(swatchInputs)
    );


  if (allInputs.length > 0) {

    /*
     * IMPORTANT:
     * Do NOT automatically select a variant on popup load.
     *
     * Only update images/display here.
     */
    updateVariantImages();
    updateSelectedColorDisplay();


    /*
     * Listen for changes.
     */
    allInputs.forEach(function (input) {
      input.addEventListener(
        "change",
        function () {

          const isSwatchInput =
            input.closest(
              ".kg-variant-picker--swatch"
            ) !== null;

          const isPillInput =
            input.closest(
              ".kg-variant-picker--pill"
            ) !== null;


          if (isSwatchInput) {

            updateSelectedVariant();
            updateSelectedColorDisplay();

          } else if (isPillInput) {

            /*
             * THIS IS THE IMPORTANT PART:
             *
             * The customer has explicitly clicked
             * a size.
             */
            window.kgFreeGiftSizeSelected = true;

            hideKgSizeRequiredMessage();

            updateSelectedVariant();

          } else {

            updateSelectedVariant();

          }
        }
      );
    });


    /*
     * Swatch click listeners.
     */
    const swatchInputsOnly =
      document.querySelectorAll(
        ".kg-variant-picker--swatch .swatch-input__input, .kg-variant-picker--swatch input[type='radio']"
      );

    swatchInputsOnly.forEach(
      function (input) {
        input.addEventListener(
          "click",
          function () {
            setTimeout(function () {
              updateSelectedColorDisplay();
              updateSelectedVariant();
            }, 10);
          }
        );
      }
    );


    /*
     * Size pill click listeners.
     */
    const pillInputs =
      document.querySelectorAll(
        ".kg-variant-picker--pill .kg-variant-radio"
      );

    pillInputs.forEach(
      function (input) {
        input.addEventListener(
          "click",
          function () {

            /*
             * Explicit size selection.
             */
            window.kgFreeGiftSizeSelected = true;

            hideKgSizeRequiredMessage();

            setTimeout(function () {
              updateSelectedVariant();
            }, 50);
          }
        );
      }
    );


    /*
     * Size label click listeners.
     */
    const pillLabels =
      document.querySelectorAll(
        ".kg-variant-picker--pill .kg-variant-label"
      );

    pillLabels.forEach(
      function (label) {
        label.addEventListener(
          "click",
          function () {

            /*
             * Explicit size selection.
             */
            window.kgFreeGiftSizeSelected = true;

            hideKgSizeRequiredMessage();

            setTimeout(function () {
              updateSelectedVariant();
            }, 50);
          }
        );
      }
    );

  } else {

    /*
     * If there is no variant picker,
     * show images without variant IDs.
     */
    const allVariantImages =
      document.querySelectorAll(
        ".kg-variant-image"
      );

    allVariantImages.forEach(
      function (img) {
        if (
          !img.getAttribute("data-variant-id")
        ) {
          img.style.display = "block";
        }
      }
    );
  }


  /*
   * Fallback for old select element.
   */
  if (kgSizeSelect) {
    kgSizeSelect.addEventListener(
      "change",
      function (e) {

        window.kgMainFreeGiftVariantId =
          Number(e.target.value);

        window.kgFreeGiftSizeSelected = true;

        hideKgSizeRequiredMessage();

        console.log(
          "Updated Free Gift Variant ID:",
          window.kgMainFreeGiftVariantId
        );
      }
    );
  }


  /*
   * SELECT BUTTON
   *
   * The customer MUST explicitly select a size.
   */
  if (kgAddToCartFreeGiftsButton) {
    kgAddToCartFreeGiftsButton.addEventListener(
      "click",
      async function (e) {

        e.preventDefault();
        e.stopPropagation();

        /*
         * No size selected:
         * block the action.
         */
        if (
          !window.kgFreeGiftSizeSelected ||
          !window.kgMainFreeGiftVariantId
        ) {
          showKgSizeRequiredMessage();
          return;
        }


        /*
         * Size selected:
         * add pump + free gifts.
         */
        if (
          typeof window.kgAddToCartFreeGifts ===
          "function"
        ) {
          const response =
            await window.kgAddToCartFreeGifts();

          console.log(response);
        }
      }
    );
  }
});